import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <Link to="/" className="flex items-center gap-2 font-heading text-lg font-bold tracking-tight cursor-pointer">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-table-2 text-base leading-none"></i>
              </span>
              <span className="text-background-50">
                USFans <span className="text-primary-400">Spreadsheet</span>
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-background-200">{t('footer.tagline')}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">{t('footer.quickLinks')}</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-200 transition-colors hover:text-background-50 whitespace-nowrap cursor-pointer">
                  {t('footer.home')}
                </Link>
              </li>
              <li>
                <Link to="/usfans-spreadsheet" className="text-background-200 transition-colors hover:text-background-50 whitespace-nowrap cursor-pointer">
                  {t('footer.guide')}
                </Link>
              </li>
              <li>
                <Link to="/#categories" className="text-background-200 transition-colors hover:text-background-50 whitespace-nowrap cursor-pointer">
                  {t('footer.categories')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">{t('footer.language')}</h4>
            <div className="mt-4">
              <LanguageSwitcher tone="dark" />
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-primary-800 pt-6">
          <p className="text-xs leading-relaxed text-background-300">{t('footer.disclaimer')}</p>
          <p className="mt-4 text-xs text-background-400">
            © {new Date().getFullYear()} USFans Spreadsheet. {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
}